import {
  FormCheckBox,
  ISelectType,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { calendarClassificationConsultationList } from "../../../../../../../services/calendarClassificationConsultation.service";
import { useWatch } from "react-hook-form";
import { OfferClassificationClassifications } from "./OfferClassificationClassifications";
import { OfferClassificationDefaultClassifications } from "./OfferClassificationDefaultClassifications";
import { TOfferClassificationForm } from "./offerClassificationSchema";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.ticketAutomationReceivedRuleOfferClassif.";

export const OfferClassificationFields = memo(() => {
  const { t } = useTranslation();

  const { sendRequest: calendarClassificationConsultationListRequest } =
    useFetch(calendarClassificationConsultationList);

  const { control, setValue } = useFormContext<TOfferClassificationForm>();

  const [classifications, setClassifications] = useState<ISelectType[]>([]);

  const requireTurnSlotClassif = useWatch({
    control,
    name: "requireTurnSlotClassif",
  });

  const updateSlotClassif = useWatch({
    control,
    name: "updateSlotClassif",
  });

  const fetchCalendarClassificationConsultationList = useCallback(async () => {
    const { data, success } =
      await calendarClassificationConsultationListRequest(null);
    if (data && success) {
      const newData = data.map((item) => ({
        id: item.identifier,
        name: item.name,
      }));
      setClassifications(newData);
    }
  }, [calendarClassificationConsultationListRequest]);

  useEffect(() => {
    fetchCalendarClassificationConsultationList();
  }, [fetchCalendarClassificationConsultationList]);

  return (
    <>
      <Grid item xs={12} sm={12}>
        <FormCheckBox
          name="requireTurnSlotClassif"
          label={
            t(translationPath + "require_turn_slot_classif") ||
            "Requires Turn Slot Classification"
          }
          onChangeCapture={() => setValue("classifications", null)}
        />
      </Grid>

      {requireTurnSlotClassif && (
        <OfferClassificationClassifications options={classifications} />
      )}

      <Grid item xs={12} sm={12}>
        <FormCheckBox
          name="updateSlotClassif"
          label={
            t(translationPath + "update_slot_classif") ||
            "When scheduling, change the slot classification"
          }
          onChangeCapture={() => setValue("defaultClassifExternal", null)}
        />
      </Grid>

      {updateSlotClassif && (
        <OfferClassificationDefaultClassifications options={classifications} />
      )}
    </>
  );
});
